import React, { useMemo } from 'react'
import { FontWeightOptionsGoogleFontsOrDefault } from './font_weight_options'
import { FormGroup } from 'shared'
import { WidgetField } from '../../live_widgets'
import { WidgetFieldFontProps } from '../types'
import { WidgetParamsKey } from 'fe_manage/live_widgets/types'
import { useFixFontToWeightMissmatch } from './use_fix_font_to_weight_missmatch'
import { useGoogleWebfontWeightsLookup } from '../googleWebfontHelper/use_google_webfonts_list'

export const FontWeight = <K extends WidgetParamsKey>({
  widget,
  formikProps: { values: formikValues, setFieldValue, handleChange },
}: WidgetFieldFontProps<K>) => {
  const values = useMemo(() => {
    if (!('fontFamily' in formikValues)) return null
    if (!('fontWeight' in formikValues)) return null
    return formikValues
  }, [formikValues])

  const googleWebfontWeights = useGoogleWebfontWeightsLookup(values?.fontFamily)

  useFixFontToWeightMissmatch({
    currentFontWeight: values?.fontWeight,
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    setFieldValue: setFieldValue,
    googleWebfontWeights: googleWebfontWeights,
  })

  if (!values) return null

  return (
    <WidgetField widget={widget} name="fontWeight" component={FormGroup}>
      <select id="fontWeight" name="fontWeight" value={values.fontWeight} onChange={handleChange}>
        <FontWeightOptionsGoogleFontsOrDefault googleWebfontWeights={googleWebfontWeights} />
      </select>
    </WidgetField>
  )
}
